<!-- start header  -->
<header>
  <app-head
    (newItemEvent)="addItem($event)"
    [titleModule]="'inquiries'"
  ></app-head>
</header>
<!-- end header  -->

<div class="row m-0">
  <!-- start sidebar  -->
  <app-sidebar
    class="col-lg-2"
    [showSide]="showSide"
    [titlepage]="'inquiries'"
  ></app-sidebar>
  <!-- end sidebar  -->
  <!-- start content page  -->
  <main class="p-4 col-lg-10">
    <!-------------------------------------------------------start view handover design--------------------------------------------------------->
				<p-toast></p-toast>
    <div class="tabview-header-container">
      <p-breadcrumb class="max-w-full" [model]="items">
        <ng-template pTemplate="item" let-item>
          <a
            [routerLink]="item.routerLink"
            class="p-menuitem-link"
            routerLinkActive="text-primary font-semibold bread-active"
          >
            <span *ngIf="item.icon" [ngClass]="item.icon" class="mr-2"></span>
            <span>{{ item.label }}</span>
          </a>
        </ng-template>
      </p-breadcrumb>
    </div>

    <div class="card p-4 bg-white">
      <div class="  ">
        <div>
          <div class="d-flex justify-content-between align-items-center py-3">
            <h5 class="txt-color">Handover</h5>
          </div>
        </div>

        <div>
          <div class="card flex justify-center mt-3">
            <p-accordion *ngIf="handover.places.length > 0" [multiple]="true">
              <p-accordionTab *ngFor="let place of handover.places">
                <ng-template pTemplate="header">
                  <div class="d-flex align-items-center">
                    <img
                      class="me-2"
                      [src]="getIconName(place?.place_Name)"
                      [alt]="place?.place_Name"
                    />
                    <span
                      style="color: #0a0c0f; font-size: 16px; font-weight: 500"
                      >{{ place?.place_Name }}</span
                    >
                  </div>
                </ng-template>

                <!-- صور المكان -->
                <div
                  class="mt-1 mb-3 row g-2"
                  *ngIf="place?.place_Images?.length"
                >
                  <div *ngFor="let img of place.place_Images" class="col-md-3">
                    <img
                      class="rounded w-100"
                      [src]="img"
                      alt="{{ place.place_Name }}"
                    />
                  </div>
                </div>

                <!-- الأسئلة -->
                <div *ngIf="place?.questions?.length">
                  <ul
                    style="
                      color: #0a0c0f;
                      font-size: 16px;
                      list-style: none;
                      padding-left: 0;
                    "
                  >
                    <li *ngFor="let que of place.questions" class="mb-2">
                      <p style="font-weight: 500; margin-bottom: 0.25rem">
                        {{ que.question }}
                      </p>
                      <div class="d-flex align-items-center">
                        <img
                          [src]="
                            que.answer === 'yes'
                              ? '/assets/images/handover/rightIcon.svg'
                              : '/assets/images/handover/wrongIcon.svg'
                          "
                          alt="Result Icon"
                          width="24"
                          height="24"
                          class="me-2"
                        />
                        <span>{{ que.answer === "yes" ? "Yes" : "No" }}</span>
                      </div>

                      <!-- صور المشكلة للسؤال -->
                      <div
                        *ngIf="que.answer !== 'yes' && que.images?.length"
                        class="mt-1 mb-3 row g-2"
                      >
                        <div *ngFor="let img of que.images" class="col-md-3">
                          <img class="rounded w-100" [src]="img" alt="issue" />
                        </div>
                      </div>

                      <div
                        class="line my-3"
                        style="width: 99%; height: 1px; background: #eef0f1"
                      ></div>
                    </li>
                  </ul>
                </div>

                <!-- شارة المشكلة + إظهار/إخفاء -->
                <div
                  *ngIf="hasProblems(place)"
                  class="alert alert-warning d-flex justify-content-between align-items-center py-2 px-3 mb-3"
                  style="
                    background: #fff6e0;
                    border: 1px solid #f4e2b5;
                    border-radius: 8px;
                  "
                >
                  <span style="color: #9d720e"
                    ><img
                      src="assets/images/alarmIcon.svg"
                      class="mb-2 pr-2"
                    />Reported Problem for this area</span
                  >
                  <button
                    pButton
                    style="color: #9d720e"
                    class="p-button-text p-0"
                    (click)="toggleProblems(place.place_ID)"
                  >
                    {{
                      showProblems[place.place_ID]
                        ? "Hide Problem"
                        : "View Problem"
                    }}
                  </button>
                </div>

                <!-- <div *ngIf="showProblems[place.place_ID]">
                 
                  <div class="mt-1 mb-3 row g-2">
                    <div
                      *ngFor="let q of place.questions"
                      class="col-md-3"
                      [hidden]="q.answer === 'yes' || !q.images.length"
                    >
                      <img
                        class="rounded w-100"
                        [src]="q.images[0]"
                        alt="problem"
                      />
                    </div>
                  </div>
                </div> -->

                <!-- الملاحظات -->
                <!-- <div style="color: #0a0c0f; font-size: 16px">
                  <h6 class="txt-color">Notes</h6>
                  <div
                    class="border rounded px-2"
                    style="border: #eef0f1 1px solid"
                  >
                    <div class="mt-3 ms-2">
                      <p>{{ place?.comment }}</p>
                    </div>
                  </div>
                </div> -->

                <div *ngIf="showProblems[place.place_ID]">
                  <!-- كل التعليقات للمكان -->
                  <ng-container
                    *ngFor="
                      let cm of place?.comments ?? [];
                      trackBy: trackByIndex
                    "
                  >
                    <!-- صور المرفقات للكومنت الحالي -->
                    <div
                      class="row g-3 mb-3"
                      *ngIf="(cm?.attachments?.length ?? 0) > 0"
                    >
                      <div
                        class="col-6 col-md-3"
                        *ngFor="let img of cm.attachments"
                      >
                        <img
                          class="rounded w-100"
                          [src]="img"
                          alt="attachment"
                        />
                      </div>
                    </div>

                    <!-- نص الكومنت -->
                    <div
                      class="border rounded px-3 py-3 mb-3"
                      style="border: #eef0f1 1px solid"
                      *ngIf="cm?.comment"
                    >
                      <p class="mb-0">{{ cm.comment }}</p>
                    </div>

                    <!------------------------------------->
               
                    <!-- أزرار (اختياري) -->
                    <div class="d-flex justify-content-between">
                      <button
                        pButton
                         (click)="onOpenRejectModal(cm.id)"
                        class="p-button-outlined btn-cancel"
                        label="Reject"
                      ></button>
                      <button
                        pButton
                        class="p-button-primary btn-confirm"
                        label="Accept"
                        (click)="approve(cm.id)"
                      ></button>
                    </div>

                     <div
                  class="line my-3"
                  style="width: 99%; height: 1px; background: #eef0f1"
                ></div>
                    <!-------------------------------------->
                  </ng-container>
                </div>

                <div
                  class="line my-3"
                  style="width: 99%; height: 1px; background: #eef0f1"
                ></div>

                <!-- أزرار (اختياري) -->
                <!-- <div class="d-flex justify-content-between">
                  <button
                    pButton
                    (click)="onOpenRejectModal()"
                    class="p-button-outlined btn-cancel"
                    label="Reject"
                  ></button>
                  <button
                    pButton
                    class="p-button-primary btn-confirm"
                    label="Accept"
                  ></button>
                </div> -->
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>

        <div class="d-flex gap-4 justify-content-end mt-4">
          <button class="btn-cancel rounded">Cancel</button>
          <button class="btn-confirm rounded" (click)="createHandover()">
            <img class="icon" src="/assets/images/handover/Marks.svg" alt="" />
            Mark As Completed
          </button>
        </div>
      </div>
    </div>

    <!------------------------------------------------------------------------------------------------------------------------------------------------->
  </main>
</div>

<!--------------------------------------------------------------------------------------------->
<div
  class="modal"
  tabindex="-1 "
  role="dialog "
  [ngStyle]="{ display: display1 }"
  style="background-color: rgb(23 22 22 / 50%)"
>
  <div class="modal-dialog" role="document ">
    <div class="modal-content" style="margin-top: 150px">
      <div
        class="modal-header"
        style="
          position: relative;
          background-color: #ffffff;
          border-bottom: none !important;
        "
      >
        <p
          class="modal-title"
          style="
            color: #1c1b1f;
            font-size: 20px;
            font-weight: 600;
            line-height: 24px;
            word-wrap: break-word;
          "
        >
          <span
            class="form-label gray"
            style="
              vertical-align: middle;
              padding-left: 8px;
              color: var(--Colors-Primary-700, #1151b4);

              font-family: Poppins;
              font-size: 18px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            "
          >
            Reason for rejection
          </span>
        </p>
        <button
          type="button "
          style="
            border: none;
            background-color: #ffffff;
            width: 68px;
            height: 50px;
          "
          class="close"
          aria-label="Close "
          (click)="onCloseModal1()"
        >
          <span aria-hidden="true " style="color: #000000; font-size: 35px"
            >&times;</span
          >
        </button>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="mb-3 col-12 col-md-12">
            <label
              for="exampleInputPricepermonth "
              class="form-label gray"
              style="
                color: var(--Colors-Base-Main-Text, #0a0c0f);

                font-family: Poppins;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
              "
              >Rejection Reason
              <span
                style="
                  color: var(--Error-40, #b3261e);

                  font-family: Poppins;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                "
                >*</span
              ></label
            >
            <textarea
              class="border p-3 pt-3 rounded-2 w-100"
              rows="4 "
              style="resize: inherit"
              placeholder="please enter reason of rejection "
              [(ngModel)]="Reason"
            ></textarea>
          </div>
          <!-- <div class="mb-3 col-12 col-md-12 ">
											<label for="exampleInputSecuritydeposit " class="form-label gray fw-bold ">Role discerption</label>
											<textarea class="border p-3 pt-3 rounded-2 w-100 " rows="5 " style="resize: inherit "></textarea>

									</div> -->
        </div>
      </div>

      <div class="modal-footer">
        <div class="d-flex justify-content-between">
          <div class="py-2 px-3 fw-bold"></div>
          <div class="d-flex justify-content-between">
            <a
              (click)="onCloseModal1()"
              style="border: 1px solid"
              class="backcancel text-decoration-none cursor bg-white rounded-2 py-2 px-3 fw-bold mx-2 xcvdd"
            >
              Cancel
            </a>
            <button
              (click)="CancelRequest()"
              class="rounded-2 text-white rounded-2 border-0 py-2 px-4"
              style="background-color: #1f4068 !important"
            >
              confirm
            </button>
          </div>
        </div>
        <!-- Confirm -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
